import { moneyFormatter } from "@/core/domain/money";
// =====================================================================
// Precio que se muestra de un servicio o variante en la página pública y
// en el panel (E2). Lógica pura.
//
// price_display:
//   fijo      → "$ 12.000" (con variantes de precios distintos: "Desde $ min")
//   desde     → "Desde $ 12.000"
//   consultar → "A consultar"
//   oculto    → no se muestra (null)
// Sin precio cargado no hay nada que mostrar (null), salvo "A consultar".
// =====================================================================

export const PRICE_DISPLAYS = ["fijo", "desde", "consultar", "oculto"] as const;
export type PriceDisplay = (typeof PRICE_DISPLAYS)[number];

const ars = moneyFormatter;

export function formatArs(amount: number): string {
  return ars.format(amount);
}

function toNumber(price: string | number | null | undefined): number | null {
  if (price === null || price === undefined || price === "") return null;
  const n = typeof price === "number" ? price : Number(price);
  return Number.isFinite(n) ? n : null;
}

/** Etiqueta de precio de UN importe (servicio sin variantes o una variante). */
export function priceLabel(
  display: PriceDisplay,
  price: string | number | null | undefined,
): string | null {
  if (display === "oculto") return null;
  if (display === "consultar") return "A consultar";
  const n = toNumber(price);
  if (n === null) return null;
  return display === "desde" ? `Desde ${formatArs(n)}` : formatArs(n);
}

/**
 * Etiqueta de precio de un servicio en la lista: si tiene variantes
 * activas con precio, manda el mínimo de ellas ("Desde" si difieren).
 */
export function servicePriceLabel(
  display: PriceDisplay,
  price: string | number | null | undefined,
  variantPrices: ReadonlyArray<string | number | null | undefined> = [],
): string | null {
  if (display === "oculto" || display === "consultar") {
    return priceLabel(display, null);
  }
  const prices = variantPrices
    .map(toNumber)
    .filter((n): n is number => n !== null);
  if (prices.length === 0) return priceLabel(display, price);

  const min = Math.min(...prices);
  const allEqual = prices.every((p) => p === min);
  if (display === "fijo" && allEqual) return formatArs(min);
  return `Desde ${formatArs(min)}`;
}
